import React from "react";
import styled from "@emotion/styled";

import { useTheme } from "../../contexts/themeContext";

function Product({ src, text, right, origin }) {
  const theme = useTheme();

  return (
    <ProductStyled theme={theme} right={right}>
      <img alt="rofl" src={src} />
      <div>
        <p>{text}</p>
        <br />
        <p>{origin}</p>
      </div>
    </ProductStyled>
  );
}

const ProductStyled = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: center;
  padding: 50px 0;
  border-top: 4px solid ${props => props.theme.secondDark};

  @media (max-width: 500px) {
    flex-direction: column;
    padding: 25px 0;
  }

  img {
    width: 50%;
    border-radius: 15px;
    order: ${props => (props.right ? 2 : -1)};

    -webkit-box-shadow: 10px 10px 27px -9px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 10px 10px 27px -9px rgba(0, 0, 0, 0.75);
    box-shadow: 10px 10px 27px -9px rgba(0, 0, 0, 0.75);

    @media (max-width: 500px) {
      width: 70%;
      margin-bottom: 25px;
      order: -1;
    }
  }

  div {
    width: 40%;
    order: 0;

    @media (max-width: 500px) {
      width: 90%;
    }

    p {
      color: ${props => props.pcolor};
      font-family: "Helvetica Neue", sans-serif;
      font-size: 15px;
      line-height: 24px;
      margin: 0 0 24px;
      text-align: justify;
      text-justify: inter-word;

      @media (max-width: 500px) {
        text-align: center;
      }
    }
  }
`;

export default Product;
